import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {environment} from '../shared/services/util.service';
import {map, switchMap} from 'rxjs/operators';
import {IHoliday, IHolidayResponse, IHolidaysResponse} from '@signal/asp-data-commons';
import {Store} from '@ngrx/store';
import {DealerState} from '../store/dealer/dealer.reducer';
import {selectDealerCode} from '../store/dealer/dealer.selectors';

@Injectable()
export class DealershipHolidaysService {

  private holidayApi: string;

  constructor(private readonly http: HttpClient,
              private readonly dealerState: Store<DealerState>) {
    this.holidayApi = environment.aspAvailabilityApi;
  }

  getHolidays(department: string): Observable<IHolidaysResponse> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.get(`${this.holidayApi}holiday/${dealerCode}/${department}`).pipe(
        map((data: IHolidaysResponse) => {
          return data;
        })
      );
    }));
  }

  createHoliday(department: string, holiday: IHoliday): Observable<IHolidayResponse> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.post(`${this.holidayApi}holiday/${dealerCode}/${department}`, holiday).pipe(
        map((data: IHolidayResponse) => {
          return data;
        })
      );
    }));
  }

  updateHoliday(department: string, id: string, holiday: IHoliday): Observable<IHolidayResponse> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.put(`${this.holidayApi}holiday/${dealerCode}/${department}/${id}`, holiday).pipe(
        map((data: IHolidayResponse) => {
          return data;
        })
      )
    }));
  }

  deleteHoliday(department: string, id: string) {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.delete(`${this.holidayApi}holiday/${dealerCode}/${department}/${id}`);
    }));
  }


}
